import {Component, OnInit, ViewChild} from '@angular/core';
import {LibraryItem} from "../../model/library";
import {Router} from "@angular/router";
import {ImageService} from "../../services/image.service";
import {LibraryService} from "../../services/library.service";
import {Subject, takeUntil} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";
import {PaymentComponent} from "../payment/payment.component";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'library-booking',
  templateUrl: './library-booking.component.html',
  styleUrls: ['./library-booking.component.less']
})
export class LibraryBookingComponent implements OnInit {

  bookingItems: LibraryItem[];
  private destroySubject: Subject<void> = new Subject();

  email: string;
  name: string;
  noValidEmail: boolean = false;
  noValidSubscription: boolean = false;


  constructor(
    private router: Router,
    public imageService: ImageService,
    public libraryService: LibraryService,
    private snackBar: MatSnackBar,
  ) {
  }

  ngOnInit(): void {

    this.bookingItems = this.libraryService.getItemsFromBookStorage();

    this.libraryService.bookingChange.pipe(
      takeUntil(this.destroySubject))
      .subscribe(event => {
        if (event?.type !== 'error') {
          this.bookingItems = this.libraryService.getItemsFromBookStorage();
        }
      })
  }

  ngOnDestroy() {
    this.destroySubject.next();
  }

  book() {

    this.noValidEmail = false;
    this.noValidSubscription = false;

    if (this.email && this.isValidEmail(this.email)) {

      this.libraryService.checkLibrarySubscription(this.email).subscribe((result) => {
        if (!result.subscriptions) {
          this.noValidSubscription = true;
        } else {
          this.libraryService.bookedRequest(this.email, this.bookingItems)
            .subscribe((result) => {
              this.libraryService.setItemsToBookStorage([]);
              this.openSnackBar("Книги успешно забронированы")
            }, error => {
              console.log("error" , error.error.error)
              this.openSnackBar(error.error.error)
            }
          )
        }
      })

    } else {
      this.noValidEmail = true;
    }
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, '', {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      duration: 3000,
      panelClass: 'text-center'

    });
  }


  isValidEmail(email: string): boolean {
    this.email = this.email.trim();
    const emailRegex = "^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$"
    let isValid = true;

    if (!this.email?.match(emailRegex)) {
      isValid = false;
    }
    return isValid;
  }

  navigate($event: any) {
    this.router.navigate([$event], {})
  }



}
